// DS: i3.14
import React from 'react';
import IconWrap from '../../IconWrap';
const Search = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.667 7.333a5.333 5.333 0 10-2.064 4.214l2.42 2.42.063.055a.667.667 0 00.88-.998l-2.42-2.42a5.31 5.31 0 001.12-3.27zm-9.334 0a4 4 0 118 0 4 4 0 01-8 0z"
    })));
Search.displayName = 'Search';
export default Search;

//# sourceMappingURL=Search.js.map